import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientGroupEntity } from './client-group.entity';
import { ItemGroupEntity } from './item-group.entity';
import { UserGroupEntity } from './user-group.entity';

@Index('group_externalId_uindex', ['deletedUserId', 'externalId'], {
	unique: true,
})
@Index('group_pk', ['name'], { unique: true })
@Index('idx_group_parent', ['fkGroupIdParent'], {})
@Entity('group')
export class GroupEntity extends BaseEntity {
	@Column('varchar', { name: 'type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('varchar', { name: 'name', unique: true, length: 64 })
	public name!: string;

	@Column('text', { name: 'description', nullable: true })
	public description!: string | null;

	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@Column('tinyint', {
		name: 'shouldAutoAddClients',
		width: 1,
		default: () => "'0'",
	})
	public shouldAutoAddClients!: boolean;

	@Column('tinyint', {
		name: 'shouldAutoAddItems',
		width: 1,
		default: () => "'0'",
	})
	public shouldAutoAddItems!: boolean;

	@Column('tinyint', {
		name: 'isSelectedByDefaultForUsers',
		width: 1,
		default: () => "'0'",
	})
	public isSelectedByDefaultForUsers!: boolean;

	@Column('tinyint', { name: 'isProtected', width: 1, default: () => "'0'" })
	public isProtected!: boolean;

	/**
	 * Parent group — the group that manages/oversees this group. One-hop
	 * traversal only for v1 (no recursive parent chains in resolution).
	 * Used by the "manager call view" feature so members of a parent group
	 * can see calls handled by users in the child group.
	 */
	@Column('int', {
		name: 'fk_group__id_parent',
		nullable: true,
		unsigned: true,
	})
	public fkGroupIdParent!: number | null;

	@ManyToOne(() => GroupEntity, {
		onDelete: 'SET NULL',
		onUpdate: 'RESTRICT',
		nullable: true,
	})
	@JoinColumn([{ name: 'fk_group__id_parent', referencedColumnName: 'id' }])
	public parentGroup!: GroupEntity | null;

	@OneToMany(() => ClientGroupEntity, (clientGroup) => clientGroup.fkGroup)
	public clientGroups!: Array<ClientGroupEntity>;

	@OneToMany(() => ItemGroupEntity, (itemGroup) => itemGroup.group)
	public itemGroups!: Array<ItemGroupEntity>;

	@OneToMany(() => UserGroupEntity, (userGroup) => userGroup.fkGroup)
	public userGroups!: Array<UserGroupEntity>;
}
